import moment from "moment";

// Champs de la fiche de chantier stockés au niveau de l'intervention.
// Les autres champs (numAgrement, numAssuranceRc, parQuiInterv, dateSignContrat)
// restent uniquement au niveau des paramètres de l'exploitation.
export const INTERVENTION_FICHE_FIELDS = [
  // Section 1002 : Commande
  "origineCmd",
  "dateCmd",
  // Section 1003 : Réalisation
  "materielInterv",
  "specichantier",
  "confPrdClient",
  "confPrdClientPrec",
  "intervPoss",
  "intervPossPrec",
  // Section 1004 : Après l'application
  "zoneTrait",
  "zoneTraitPrec",
  "dosePrdResp",
  "dosePrdRespPrec",
  "consiResp",
  "consiRespPrec",
  "incident",
  "incidentPrec",
  "gestEffluent",
  "gestEvppClient",
  // Section 1005 : Consignes de sécurité
  "respectZnt",
  "respectZntPrec",
  "respectDvp",
  "respectDvpPrec",
];

// Extrait depuis les paramètres uniquement les champs présents au niveau intervention.
export const pickInterventionFieldsFromParams = (paramsFicheChantier) => {
  return INTERVENTION_FICHE_FIELDS.reduce((acc, field) => {
    acc[field] = paramsFicheChantier[field];
    return acc;
  }, {});
};

// Règles métier de pré-remplissage de la date de commande :
// - Origine = Contrat (id 2) ET dateSignContrat des paramètres rempli => dateSignContrat
// - Tous les autres cas (Oral, Texto, Mail, Indéterminé, ou Contrat sans dateSignContrat)
//   => date d'intervention - 1 jour
export const computeDefaultDateCmd = (origineCmd, dateIntervention, dateSignContrat) => {
  if (!dateIntervention) return "";
  const origineId = Array.isArray(origineCmd) && origineCmd[0] ? origineCmd[0].id : null;
  if (origineId === 2 && dateSignContrat) {
    return dateSignContrat;
  }
  return moment(dateIntervention).subtract(1, "day").format("YYYY-MM-DD");
};

// Filet de sauvegarde appelé au moment de l'enregistrement de l'intervention :
// fusionne les paramètres avec les overrides de l'intervention (les overrides priment),
// puis applique le pré-remplissage de dateCmd si toujours vide.
// Garantit que l'intervention envoyée au serveur contient toujours une fiche complète.
export const buildFicheChantierForSave = (intervention, paramsFicheChantier) => {
  const paramsDefaults = pickInterventionFieldsFromParams(paramsFicheChantier);
  const merged = {
    ...paramsDefaults,
    ...(intervention.ficheChantier || {}),
  };
  if (!merged.dateCmd) {
    merged.dateCmd = computeDefaultDateCmd(
      merged.origineCmd,
      intervention.date,
      paramsFicheChantier.dateSignContrat
    );
  }
  return merged;
};
